import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker, DateRangePickerProps } from '@mui/x-date-pickers-pro/DateRangePicker';
import { useTranslations } from 'next-intl';
import { LocalizationProvider } from 'node_modules/@mui/x-date-pickers/esm/LocalizationProvider/LocalizationProvider';
import { useEventTimeFilter } from './utils/useEventTimeFilter';

const EventTimeFilter = ({ sx, onChange, ...props }: DateRangePickerProps) => {
  const t = useTranslations('entryIndex');
  const filter = useEventTimeFilter();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        label={t('selectDate')}
        showDaysOutsideCurrentMonth
        calendars={1}
        onChange={filter.handleChange}
        slotProps={{
          textField: {
            color: 'secondary',
          },
        }}
        sx={{
          fieldset: { borderColor: 'secondary.light' },
          ...sx,
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default EventTimeFilter;
